export default __webpack_public_path__ + "static/99sense-logo-c436cdad64665e799411901be858c949.svg";